import type {RouteObject, LoaderFunctionArgs} from 'react-router';
import type {ComponentType} from 'react';

export type Route = {
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  import: () => Promise<any>;
  options?: Omit<RouteObject, 'path' | 'element' | 'lazy' | 'index'>;
};

export type RouteLoaderArgs<
  Props extends Record<string, unknown> = Record<string, unknown>,
> = LoaderFunctionArgs & {
  initialProps: Props;
};

export function generateRoutes(
  routes: Route[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialProps?: Record<string, any>
): RouteObject[] {
  return routes.map(route => {
    const path = route.path;
    const props = initialProps?.[path] || {};

    const routeObject: RouteObject = {
      path,
      lazy: async () => {
        const module = await route.import();

        const result: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          Component: ComponentType<any>;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          loader?: (args: LoaderFunctionArgs) => any;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          action?: (args: LoaderFunctionArgs) => any;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ErrorBoundary?: ComponentType<any>;
        } = {
          Component: module.default,
        };

        if (module.loader) {
          result.loader = async (args: LoaderFunctionArgs) => {
            return await module.loader({
              ...args,
              initialProps: props,
            });
          };
        }

        if (module.action) result.action = module.action;
        if (module.ErrorBoundary) result.ErrorBoundary = module.ErrorBoundary;

        return result;
      },
      ...route.options,
    };

    return routeObject;
  });
}
